import { cn } from '@/lib/utils';

const palette = [
  'bg-[#DBEAFE] text-[#1D4ED8]',
  'bg-[#DCFCE7] text-[#15803D]',
  'bg-[#FEF3C7] text-[#B45309]',
  'bg-[#EDE9FE] text-[#6D28D9]',
  'bg-[#FCE7F3] text-[#BE185D]',
  'bg-[#CCFBF1] text-[#0F766E]',
  'bg-[#FEE2E2] text-[#B91C1C]',
  'bg-[#E0E7FF] text-[#4338CA]',
];

function hash(str: string) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h << 5) - h + str.charCodeAt(i);
  return Math.abs(h);
}

function initials(name: string) {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const sizes = {
  sm: 'h-7 w-7 text-[11px]',
  md: 'h-9 w-9 text-[13px]',
  lg: 'h-11 w-11 text-sm',
};

export function Avatar({
  name,
  size = 'md',
  className,
}: {
  name: string;
  size?: keyof typeof sizes;
  className?: string;
}) {
  const color = palette[hash(name || '?') % palette.length];
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full font-semibold',
        sizes[size],
        color,
        className,
      )}
      aria-hidden
    >
      {initials(name || '?')}
    </span>
  );
}
